
import Component from "vue-class-component";
import Enumerable from "linq";
import { Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { Document, IDocumentImageSource } from "../../../../documaker/domain/document";
import { IEditableFormatDocumentRepository, EditableFormatDocument } from "../../../domain/editableFormat";
import { IFormatObjectBean } from "../../../infrastructure/editableFormat/ver2/beans";
import { IContentSource } from "../../../../base/domain/drawing";

@Component
export default class NewDocumentViewMixin extends Mixins() {
  async createNewFormatDocument(patientNo: string, formatId: number, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string, archiveId: number, editingFormat: IFormatObjectBean): Promise<Document> {
    return editingFormat
      ? this.getNewStoredDocumentStructure(patientNo, editingFormat, institutionNo, regionalInstitutionNo, hisInfoGetterParameter)
      : this.getNewDocumentStructure(patientNo, formatId, institutionNo, regionalInstitutionNo, hisInfoGetterParameter, archiveId);
  }

  private async createFormatDocumentInstance(request: string, create: (r: IEditableFormatDocumentRepository) => Promise<Document>, shouldShowLoading: boolean = true): Promise<Document> {
    return this.createFormatDocument(
      request,
      () => create(DomainRegistry.instance.editableFormat.getDocumentRepository()),
      shouldShowLoading);
  }

  async createFormatDocument(request: string, create: () => Promise<Document>, shouldShowLoading: boolean = true): Promise<Document> {
    this.$logger.info(request + "を取得します。");
    return create();
  }

  async getNewDocumentStructure(patientNo: string, formatId: number, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string, archiveId: number): Promise<Document>  {
    return this.createFormatDocumentInstance(
      "選択中" + this.$wording.format.name + "の文書編集プレビュー用の新規文書",
      async r => {
        return r.getNewDocumentStructure(patientNo, formatId, institutionNo, regionalInstitutionNo, hisInfoGetterParameter, archiveId);
      });
  }

  async getNewStoredDocumentStructure(patientNo: string, format: IFormatObjectBean, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string): Promise<Document> {
    return this.createFormatDocumentInstance(
      "選択中" + this.$wording.format.name + "の編集中文書プレビュー用の新規文書",
      async r => {
        return r.getNewStoredDocumentStructure(patientNo, format, institutionNo, regionalInstitutionNo, hisInfoGetterParameter);
      });
  }

  async getFormatReferenceFile(fileId: number | string, document: EditableFormatDocument): Promise<IContentSource> {
    return Enumerable.from(document.referenceFileContentSource)
      .where(s => s.id === fileId)
      .select(s => s.source)
      .firstOrDefault();
  }

  async createImageSource(imageText: string): Promise<IDocumentImageSource> {
    return DomainRegistry.instance.editableFormat.getDocumentRepository().createImageSource(imageText);
  }

  async createPreviewCacheSource(document: Document, format: IFormatObjectBean, formatId: number): Promise<IContentSource> {
    return format
      ? DomainRegistry.instance.editableFormat.getDocumentRepository().createNewStoredDocumentPdfSource(document, format)
      : DomainRegistry.instance.editableFormat.getDocumentRepository().createNewDocumentPdfSource(document, formatId);
  }

  async createPrintCacheSource(document: Document, format: IFormatObjectBean, formatId: number): Promise<IContentSource> {
    return format
      ? DomainRegistry.instance.editableFormat.getDocumentRepository().createNewStoredDocumentPrintPdfSource(document, format)
      : DomainRegistry.instance.editableFormat.getDocumentRepository().createNewDocumentPrintPdfSource(document, formatId);
  }

  async getExtraDocument(patientNo: string, formatId: number): Promise<Document> {
    const formatArchives = await DomainRegistry.instance.editableFormat.getFormatRepository().getFormatArchives(formatId);
    if (!formatArchives) { return null; }
    const archiveId = Enumerable.from(formatArchives).orderByDescending(e => e.archiveId).first().archiveId;
    return this.getNewDocumentStructure(patientNo, formatId, undefined, undefined, undefined, archiveId);
  }
}
